import { useState } from 'react';
import Fraction from '../components/Fraction';

const SVG_WIDTH  = 500;
const SVG_HEIGHT = 85;
const LINE_X0    = 50;
const LINE_X1    = 450;
const LINE_Y     = 50;
const LINE_LENGTH = LINE_X1 - LINE_X0;

export default function NumberLineQuestion({ question, onAnswer, disabled }) {
  const { num, den } = question.data;
  const [selected, setSelected] = useState(null);

  // Generate ticks at 0, 1/den, 2/den, ..., 1
  const ticks = [];
  for (let i = 0; i <= den; i++) {
    ticks.push({
      fraction: { num: i, den },
      x: LINE_X0 + (i / den) * LINE_LENGTH,
      label: i === 0 ? '0' : i === den ? '1' : `${i}/${den}`,
      isEndpoint: i === 0 || i === den,
    });
  }

  function handleTickClick(tick) {
    if (disabled || tick.isEndpoint) return;
    setSelected(tick);
  }

  function handleSubmit() {
    if (!selected || disabled) return;
    onAnswer({ num: selected.fraction.num, den: selected.fraction.den });
    setSelected(null);
  }

  return (
    <div className="question-card">
      <p className="question-prompt">
        Atrod{' '}
        <Fraction num={num} den={den} size="md" />
        {' '}uz skaitļu taisnes!
      </p>
      <p className="number-line-instruction">Nospied uz pareizā punkta, tad apstiprin.</p>

      <svg
        width="100%"
        viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
        className="number-line-svg"
        style={{ userSelect: 'none' }}
      >
        {/* Main line */}
        <line
          x1={LINE_X0} y1={LINE_Y}
          x2={LINE_X1} y2={LINE_Y}
          stroke="#555" strokeWidth="2"
        />
        {/* Left arrowhead */}
        <polygon
          points={`${LINE_X0 - 10},${LINE_Y} ${LINE_X0},${LINE_Y - 6} ${LINE_X0},${LINE_Y + 6}`}
          fill="#555"
        />
        {/* Right arrowhead */}
        <polygon
          points={`${LINE_X1 + 10},${LINE_Y} ${LINE_X1},${LINE_Y - 6} ${LINE_X1},${LINE_Y + 6}`}
          fill="#555"
        />

        {/* Ticks */}
        {ticks.map((tick, idx) => {
          const isSelected =
            selected &&
            selected.fraction.num === tick.fraction.num &&
            selected.fraction.den === tick.fraction.den;
          const color = isSelected ? '#e07b00' : '#555';

          return (
            <g
              key={idx}
              onClick={() => handleTickClick(tick)}
              style={{ cursor: tick.isEndpoint ? 'default' : (disabled ? 'not-allowed' : 'pointer') }}
            >
              {/* Invisible hit area */}
              {!tick.isEndpoint && (
                <rect
                  x={tick.x - 16}
                  y={LINE_Y - 24}
                  width={32}
                  height={48}
                  fill="transparent"
                />
              )}

              {/* Highlight circle for selected */}
              {isSelected && (
                <circle
                  cx={tick.x}
                  cy={LINE_Y}
                  r={12}
                  fill="#ffb347"
                  stroke="#e07b00"
                  strokeWidth={2}
                />
              )}

              {/* Tick mark */}
              <line
                x1={tick.x} y1={LINE_Y - 8}
                x2={tick.x} y2={LINE_Y + 8}
                stroke={color}
                strokeWidth={isSelected ? 3 : 2}
              />

              {/* Endpoint labels only */}
              {tick.isEndpoint && (
                <text
                  x={tick.x}
                  y={LINE_Y + 24}
                  textAnchor="middle"
                  fontSize="13"
                  fontWeight="600"
                  fill="#444"
                >
                  {tick.label}
                </text>
              )}
            </g>
          );
        })}
      </svg>

      <button
        className="submit-btn"
        onClick={handleSubmit}
        disabled={!selected || disabled}
      >
        Apstiprināt
      </button>
    </div>
  );
}
